import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducer';
// import { composeWithDevTools } from 'redux-devtools-extension';
import { composeWithDevTools } from 'remote-redux-devtools';


// kreiramo Redux store
/*
// export const store = createStore(rootReducer); // najprostiji store bez debuggera
// export const store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()); // NOVO store koji omgucava koriscenje browser ekstenzije Redux DevTools Extension
// If you setup your store with middleware and enhancers, change:
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk)
)); // NOVO store koji podrzava i thunk i redux-dev-tools i React Native Debugger
export default store;
*/


// 2024-11-25

// https://redux.js.org/usage/migrating-to-modern-redux
// https://github.com/zalmoxisus/redux-devtools-extension

const middlewareEnhancer = applyMiddleware(thunk);
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose; // For universal ("isomorphic") apps
const composedEnhancers = composeEnhancers(middlewareEnhancer);
// const composedEnhancers = composeWithDevTools(middlewareEnhancer);
// const composedEnhancers = composeWithDevTools(middlewareEnhancer);
const store = createStore(rootReducer, composedEnhancers);
export default store;